import Image from 'next/image';
import Link from 'next/link';
import menuIcon from '/public/icons/icons8-menu-35.png';
import SubMenu from './SubMenu';
import SearchBar from './SearchBar';
import { useState, useMemo } from 'react';
import { NavBarRoutes } from '@/data/businessData';

const MobileMenu = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const navRoutes = useMemo(() => Object.values(NavBarRoutes), []);

  const handleNavLinkClick = () => {
    setIsMobileOpen(false);
  };

  return (
    <div>
      <button
        type="button"
        className={`absolute top-0 right-0 flex min-h-[44px] min-w-[44px] cursor-pointer items-center justify-center p-4 focus:ring-2 focus:ring-white focus:ring-offset-2 focus:outline-none ${isMobileOpen ? 'h-screen overflow-y-scroll' : 'h-fit'}`}
        onClick={() => setIsMobileOpen(true)}
        aria-label="Open Menu"
        title="Open Menu"
      >
        <Image src={menuIcon} alt="" className="cursor-pointer" />
      </button>

      <div
        className={`fixed top-0 right-0 z-40 h-full w-3/4 max-w-sm overflow-y-auto border-l bg-brittainRed p-6 shadow-2xl transition-transform duration-300 ease-in-out lg:hidden ${
          isMobileOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <button
          type="button"
          onClick={() => setIsMobileOpen(false)}
          className="absolute top-4 right-4 flex min-h-[44px] min-w-[44px] items-center justify-center text-3xl font-light text-white focus:text-brittainMidnightBlue focus:ring-2 focus:ring-white focus:ring-offset-2 focus:outline-none"
          aria-label="Close Menu"
        >
          &times;
        </button>

        {/* Mobile Search Input */}
        <nav className="mt-16 flex flex-col gap-y-6 text-lg font-medium tracking-wide uppercase">
          {navRoutes.map((route) => (
            <div key={route.label}>
              <Link
                href={route.href}
                className="text-white focus:text-brittainMidnightBlue"
                onClick={handleNavLinkClick}
              >
                {route.label}
              </Link>

              {route.hasSubLinks && (
                <div className="ml-4 flex flex-col pt-8 pb-4 text-white focus:text-brittainMidnightBlue">
                  <SubMenu routes={route.subLinks} onLinkClick={handleNavLinkClick} />
                </div>
              )}
            </div>
          ))}

          <div className="relative">
            <SearchBar variant="mobile" />
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
